import React from 'react';
import img from '../../images/DigitalLibrary.png';
import { AccountFormWrap, Card, Container, FormButton, FormContent, FormH1, FormH2, SpinningIcon, LinkButton, ThumbnailImage } from './AccountElements';

const SubcriptionOverview = ({ subscriptionDetails, email, loadingBoolean, cancelSubscription }) => {

    // Function to format date
    const formatDate = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const day = date.getDate();
        const month = date.getMonth() + 1; // months are zero-indexed
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    // Determine the date string based on the subscription status
    const createString = subscriptionDetails.active
        ? `Subscription created on ${formatDate(subscriptionDetails.created)}`
        : ``;

    const cancelString = subscriptionDetails.canceledAt
        ? `Subscription canceled at ${formatDate(subscriptionDetails.canceledAt)}`
        : ``;

    const cancelAtString = subscriptionDetails.cancelAt
        ? `Subscription level access will end on ${formatDate(subscriptionDetails.cancelAt)}`
        : ``;
    return (
        <Card>
            <ThumbnailImage src={img} />
            <>
                {subscriptionDetails.active ? (
                    <>
                        <FormH2>Active Subscription under {email}</FormH2>
                        <FormH2>{createString}</FormH2>
                        <FormH2>{cancelString}</FormH2>
                        <FormH2>{cancelAtString}</FormH2>
                        {loadingBoolean && <SpinningIcon />}
                        <FormButton disabled={loadingBoolean || subscriptionDetails.canceled} onClick={cancelSubscription}>Cancel</FormButton>
                    </>
                ) : (
                    <>
                        <FormH2 style={{ textAlign: 'center', marginTop: '12px' }}>There are no active subscriptions</FormH2>
                        <FormH2 style={{ textAlign: 'center', marginTop: '12px', color: 'grey', maxWidth: '90%' }}>
                            Subscribe by starting a new book
                        </FormH2>
                        <LinkButton to={'/mylibrary'} style={{ marginTop: '12px' }}> My Library </LinkButton>
                    </>
                )}
            </>
        </Card>
    );
};

export default SubcriptionOverview;

